module.exports = __webpack_public_path__ + "static/media/orlando.576b9e5f.jpg";